import { Box, Tooltip, Typography } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import React from "react";

type SummaryItemProps = {
    title: string;
    tooltip: string;
    children: React.ReactNode;
};

export const SummaryItem = ({ title, tooltip, children }: SummaryItemProps) => {
    return (
        <Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography variant="h6" color="primary">
                    {title}
                </Typography>
                <Tooltip
                    title={tooltip}
                    arrow
                    slotProps={{
                        tooltip: {
                            sx: {
                                whiteSpace: "pre-line",
                            },
                        },
                    }}
                >
                    <HelpOutlineIcon color="action" sx={{ fontSize: 18, cursor: "pointer" }} />
                </Tooltip>
            </Box>
            <Box sx={{ pt: 0.5 }}>{children}</Box>
        </Box>
    );
}; 